<template>
  <footer>
    <div class="footer-div1">
      <router-link to="/terms" class="link">Terms of Service</router-link>
      <span class="footer-line">|</span>
      <router-link to="/policy" class="link">Privacy Policy</router-link>
      <span class="footer-line">|</span>
      <router-link to="/about" class="link">About Us</router-link>
      <span class="footer-line">|</span>
      <router-link to="/contact" class="link">Contact Us</router-link>
    </div>
    <div class="footer-footer">
      <img src="https://cdn.rokit.gg/web-img/logo.png" style="height: 25px;margin-right: 25px">
      <span>Copyright @ {{ currentYear }} RoKit</span>
    </div>
  </footer>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Footer",
  setup() {
    let currentYear = new Date().getFullYear();
    return {
      currentYear
    }
  },
}
</script>

<style scoped lang="scss">
footer{
  background-color: #000000;
  color: #ffffff;
  height: 170px;
  .footer-div1{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-top: 40px;
    .link{
     cursor: pointer;
    }
  }
  .footer-text1{
    padding-top: 40px;
  }
  .footer-line{
    margin: 0 30px;
  }
  .footer-footer{
    margin-top: 40px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>